import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EstensaSettingsType, SearchParam, SearchParams } from '../../search-param.model';
import { AdminPagesUserPreference, UserPreferences } from 'estensa-module';
import { SearchPageConfigurationService } from '../../search-page-configuration.service';
import { SearchPageService } from '../../search-page.service';
import { removeData, userSearchParam } from '../../helpers';
import { SearchFormType } from '../../search-page-type.enum';

@Component({
    selector: 'se-ap-search-filters-config',
    templateUrl: './ap-search-filters-config.component.html',
    styleUrls: ['./ap-search-filters-config.component.scss'],
    standalone: false
})
export class ApSearchFiltersConfigComponent {
    filters: SearchParam[] = [];

    @Input()
    set searchParams(params: SearchParams) {
        this.filters = params.searchParamsGroupedByRow.flat();
    }

    @Input()
    formType!: SearchFormType;
    @Input() isCurrentUserAuthorized: () => boolean = () => false;

    @Output() changeFilters: EventEmitter<SearchParams> = new EventEmitter();

    constructor(
        private searchPageConfigurationService: SearchPageConfigurationService,
        private searchPageService: SearchPageService,
    ) {}

    onChangeFilters = (filters: SearchParam[]) => {
        const searchParams = new SearchParams(filters);
        searchParams.endAllDataLoading();
        this.changeFilters.emit(searchParams);
    };

    /**
     * Questo metodo estrae la parte 'salvabile' del setting e esegue il salvataggio
     * @param settingsType
     */
    saveSettings = (settingsType: EstensaSettingsType): void => {
        /*e` la stessa chiamata sia per sito che per user, ci pensa il search page config service a
        chiamare l'endpoint corretto in base al settingsType*/
        try {
            /** rimuovo i dati delle options delle combo prima di salvare */
            const filters = this.filters.map(removeData);

            /** estraggo solo le proprietà a livello di user, rimuovo value e default value*/
            const userFilters = filters.map(userSearchParam);

            this.searchPageConfigurationService.storeAndSaveFiltersState(userFilters, this.formType, settingsType);
        } catch (err) {
            console.error(err);
        }
    };

    resetDefaultSettings = (settingsType: EstensaSettingsType) => {
        const defaultParams = this.searchPageService.getSearchParams(this.formType);
        if (settingsType === EstensaSettingsType.user) {
            this.searchPageConfigurationService
                .getDefaultConfigurationUserPreferences() // Ritorna il valore del setting attualmente impostato per il sito (che si trova nel current value del settings per sito)
                .subscribe((preferences: UserPreferences) => {
                    const adminUserPagePreference =
                        preferences.adminPagesUserPreference?.[this.formType as keyof AdminPagesUserPreference] ?? null;
                    if (adminUserPagePreference?.filters) {
                        try {
                            // Scarico la parte per user del setting (quella modificabile da interfaccia)
                            const executionUserSearchFilter: SearchParam[] = JSON.parse(
                                adminUserPagePreference.filters,
                            );

                            // ricreo il setting completo
                            this.filters =
                                this.searchPageService.mergeExecutionFilterSettings(executionUserSearchFilter);
                            this.onChangeFilters(this.filters);

                            this.saveSettings(EstensaSettingsType.user);
                        } catch (err) {
                            console.error(err);
                            /*replico il set dei parametri di default
                             * un errore qui puo essere solo dovuto alla stringa dei filtri corrotta che rompe il JSON.parse*/
                            this.onChangeFilters(defaultParams.searchParamsFullGroupedByRow.flat());
                        }
                    } else {
                        this.onChangeFilters(defaultParams.searchParamsFullGroupedByRow.flat());
                    }
                });
        } else if (settingsType === EstensaSettingsType.site) {
            // Carico i valori di fabbrica e li salvo
            this.filters = this.searchPageService.getDefaultSiteExecutionFilter();
            this.onChangeFilters(this.filters);

            this.saveSettings(EstensaSettingsType.site);
        }
    };

    stopPropagation(event: MouseEvent) {
        event.stopPropagation();
    }
}
